@if (!tab.showLoader) {
    @if (thirdParty) {
        <div data-uiid="third-party-page">
            <div menuSystem [cerrixTab]="tab" (changeEvent)="handleMenuItemClick($event)">
                <div class="detail-page-action-bar flex-action-bar">
                    <div class="col-md-12 text-start">
                        @if (!permissions.readOnly) {
                            <button
                                data-uiid="thirdparty-save"
                                class="btn btn-cerrix btm-sm"
                                (click)="save()"
                            >
                                <i class="fas fa-save"></i>
                                <span class="d-none d-lg-inline">Save third party</span>
                            </button>
                        }
                        @if (thirdParty.Guid) {
                            <span class="date-edited">
                                Last save: {{ thirdParty.DateModified | dateTimeFormat }}
                            </span>
                        }
                    </div>
                </div>

                <div
                    class="thirdparty-screens"
                    menuicon="fas fa-handshake"
                    name="Third Party"
                    menusystemsubmenu
                >
                    <div
                        data-uiid="thirdpartydetail-main"
                        menuItemId="details"
                        name="Details"
                        menuicon="fas fa-info-circle"
                        menusystemitem
                    >
                        <uc-thirdparty-detail-main
                            class="uc"
                            [thirdParty]="thirdParty"
                            [sd]="sd"
                            [parentForm]="parentForm"
                            [readonly]="permissions.readOnly"
                            [permissions]="permissions"
                        >
                        </uc-thirdparty-detail-main>
                    </div>
                    @if (thirdParty.Guid) {
                        <div
                            data-uiid="thirdpartydetail-contracts"
                            menuItemId="contracts"
                            name="Contracts"
                            menuicon="fas fa-file-signature"
                            menusystemitem
                        >
                            <thirdparty-contracts-overview
                                [thirdParty]="thirdParty"
                                [permissions]="permissions"
                                #thirdpartyContractsOverviewComponent
                            >
                            </thirdparty-contracts-overview>
                        </div>
                        <div [attr.name]="'Links'" menuicon="fas fa-link" menusystemsubmenu>
                            <div
                                data-uiid="thirdpartydetail-risks"
                                menuItemId="risks"
                                name="Risks"
                                menuicon="fas fa-exclamation-triangle"
                                menusystemitem
                            >
                                <thirdparty-risks
                                    [model]="thirdParty"
                                    [disabled]="!permissions.canLinkRisks"
                                    #thirdpartyRisksComponent
                                >
                                </thirdparty-risks>
                            </div>
                            <div
                                data-uiid="thirdpartydetail-controls"
                                menuItemId="controls"
                                name="Controls"
                                menuicon="fas fa-shield-alt"
                                menusystemitem
                            >
                                <thirdparty-controls
                                    [model]="thirdParty"
                                    [disabled]="!permissions.canLinkControls"
                                    #thirdpartyControlsComponent
                                >
                                </thirdparty-controls>
                            </div>
                            <div
                                data-uiid="thirdpartydetail-moi"
                                menuItemId="moi"
                                name="Measures of Improvement"
                                menuicon="fas fa-tasks"
                                menusystemitem
                            >
                                <linked-moi-overview
                                    data-uiid="thirdpartymoi-moilinkable"
                                    [parentGuid]="thirdParty.Guid"
                                    [moiType]="tpMoiType"
                                    [canAdd]="permissions.canAddMoi"
                                    [canDelete]="permissions.canEdit"
                                    #thirdpartyMoisComponent
                                >
                                </linked-moi-overview>
                            </div>

                            @if (useIncidents) {
                                <div
                                    data-uiid="thirdpartydetail-incidents"
                                    menuItemId="incidents"
                                    name="Incidents"
                                    menuicon="fas fa-bolt"
                                    menusystemitem
                                >
                                    <thirdparty-incidents
                                        data-uiid="thirdpartyincidents-incidentlinkable"
                                        [model]="thirdParty"
                                        [disabled]="true"
                                        #thirdpartyIncidentsComponent
                                    ></thirdparty-incidents>
                                </div>
                            }
                            <div
                                data-uiid="thirdpartydetail-forms"
                                menuItemId="forms"
                                name="Forms"
                                menuicon="fad fa-file-alt"
                                menusystemitem
                            >
                                <thirdparty-linked-forms
                                    data-uiid="thirdparty-formlinkable"
                                    [model]="thirdParty"
                                    [disabled]="!permissions.canLinkForms"
                                    #thirdPartyFormsComponent
                                >
                                </thirdparty-linked-forms>
                            </div>
                            <div
                                data-uiid="thirdpartydetail-documents"
                                menuItemId="documents"
                                name="Documents"
                                menuicon="far fa-file"
                                menusystemitem
                            >
                                <document-manager-old
                                    data-uiid="thirdpartydocuments-documentmanager"
                                    [(Documents)]="thirdParty.Documents"
                                    [permissions]="permissions.documentPermissions"
                                    [DocumentTypeTargets]="targetModule"
                                >
                                </document-manager-old>
                            </div>
                            <div
                                name="Hyperlinks"
                                [attr.menuItemID]="hyperlinksMenuItemId"
                                menuicon="fas fa-external-link-alt"
                                menusystemitem
                            >
                                @if (thirdParty.Hyperlinks) {
                                    <div>
                                        <hyperlink-manager
                                            [(Hyperlinks)]="thirdParty.Hyperlinks"
                                            (HyperlinksChanged)="checkHyperlinksDirty($event)"
                                            [TargetModule]="targetModule"
                                        ></hyperlink-manager>
                                    </div>
                                } @else {
                                    <div>
                                        <div class="fancy-loader"></div>
                                    </div>
                                }
                            </div>
                        </div>
                        <div
                            menuItemId="history"
                            name="History"
                            menuicon="fas fa-history"
                            menusystemitem
                        >
                            <app-history-overview
                                [Id]="thirdParty.Guid"
                                [historyDataService]="dataservice"
                                #historyDetailOverviewComponent
                            ></app-history-overview>
                        </div>

                        <div
                            data-uiid="thirdpartydetail-options"
                            name="Options"
                            menuicon="fas fa-check-double"
                            menusystemitem
                        >
                            <detail-options
                                moduleName="third party"
                                [objectName]="thirdParty ? thirdParty.Name : 'thirdparty'"
                                [allowDelete]="permissions.canDelete"
                                (onDelete)="delete()"
                            >
                            </detail-options>
                        </div>
                    }
                </div>
            </div>
        </div>
    }
} @else {
    <div>
        <div class="fancy-loader"></div>
    </div>
}
